import { Prospect } from "types";

interface UserRendererProps {
  prospect: Prospect;
}

export function UserRenderer(props: UserRendererProps) {
  return (
    <ul>
      <li>Company name: {props.prospect?.companyName}</li>
      <li>uuid: {props.prospect?.uuid}</li>
      <li>dba: {props.prospect?.dba}</li>
      <li>ein: {props.prospect?.ein}</li>
    </ul>
  );
}
